export default __webpack_public_path__ + "static/media/Group 3222@2x.6c0b7273.png";